import { Box, Chip, Typography } from '@mui/joy';

/** The same delivery state in Sales and in the linked Account's timeline. */
export function WelcomeEmailStatus({ metadata }: { metadata: Record<string, unknown> }) {
  if (metadata.source !== 'inquiry_welcome') return null;
  const status = String(metadata.status || 'queued');
  return (
    <Box sx={{ mt: 1, display: 'grid', gap: 0.5 }}>
      <Chip
        size="sm"
        variant="soft"
        color={
          status === 'sent' ? 'success' : ['failed', 'uncertain'].includes(status) ? 'warning' : 'neutral'
        }
      >
        {String(metadata.status_label || 'Queued')}
      </Chip>
      <Typography level="body-xs" sx={{ overflowWrap: 'anywhere' }}>
        Welcome email · {String(metadata.segment || 'Unknown company size')}
        {Array.isArray(metadata.to) ? ` · To ${metadata.to.join(', ')}` : ''}
      </Typography>
      <Typography level="body-xs" sx={{ overflowWrap: 'anywhere' }}>
        From {String(metadata.from || '')} · Reply-to {String(metadata.reply_to || '')}
      </Typography>
      {!!metadata.delivery_error && (
        <Typography level="body-sm" color="warning">
          {String(metadata.delivery_error)}
        </Typography>
      )}
    </Box>
  );
}
